export const QUIZ_GRID_PAGE_SIZE = 9;
export const QUIZ_LIST_PAGE_SIZE = 10;

export default function Pagination({
    page,
    pageSize,
    totalItems,
    text,
    onPageChange
}) {
    const pageCount = Math.ceil(totalItems / pageSize);
    if (pageCount < 2) {
        return null;
    }

    const currentPage = Math.min(page, pageCount);
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalItems);

    return (
        <nav className="pagination" aria-label={text.paginationNavLabel}>
            <span className="pagination-summary">
                {text.paginationSummary
                    .replace("{start}", String(start))
                    .replace("{end}", String(end))
                    .replace("{total}", String(totalItems))}
            </span>
            <div className="pagination-controls">
                <button
                    className="quiz-secondary-btn"
                    type="button"
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    {text.previousPage}
                </button>
                <span className="pagination-page" aria-current="page">
                    {text.paginationPage
                        .replace("{page}", String(currentPage))
                        .replace("{pages}", String(pageCount))}
                </span>
                <button
                    className="quiz-secondary-btn"
                    type="button"
                    disabled={currentPage === pageCount}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    {text.nextPage}
                </button>
            </div>
        </nav>
    );
}
